import type React from 'react';
import { getFullName } from '@shared/helpers';
import type { Client } from '@shared/types/users';
import * as st from './styles.module.scss';

type Props = {
  client: Client;
};

export const Name: React.FC<Props> = ({ client }) => {
  return client && <h3 className={st.name}>{client && getFullName(client)}</h3>;
};
